if (!customElements.get('fs-product-slider')) {
  customElements.define(
    'fs-product-slider',
    class FsProductSlider extends HTMLElement {
      constructor() {
        super();
        this.isInit = false;
        this.collectionId = this.dataset.collectionId;
        this.collectionHandle = this.dataset.collectionHandle;
        this.productsPerPage = 12;
      }

      connectedCallback() {
        if (this.isInit) return;

        this.pollForFastSimonSdk()
          .then(() => this.init())
          .catch(() => {});
      }

      pollForFastSimonSdk() {
        const pollIntervalMs = 150;
        const pollTimeoutMs = 10000;

        return new Promise((resolve, reject) => {
          const startTimestampMs = Date.now();

          const pollTick = () => {
            const available =
              typeof window !== 'undefined' &&
              window.FastSimonSDK &&
              typeof window.FastSimonSDK.smartCollections === 'function';

            if (available) {
              resolve(true);
              return;
            }

            if (Date.now() - startTimestampMs > pollTimeoutMs) {
              reject(new Error('FastSimonSDK not available'));
              return;
            }

            setTimeout(pollTick, pollIntervalMs);
          };

          pollTick();
        });
      }

      init() {
        if (this.isInit) return;
        this.isInit = true;

        this.collectionId = this.dataset.collectionId;
        this.collectionHandle = this.dataset.collectionHandle;

        window.FastSimonSDK.smartCollections({
          categoryID: this.collectionId,
          page: 1,
          productsPerPage: this.productsPerPage,
          callback: (response) => this.renderHits(response)
        });
      }

      renderHits(response) {
        const products = (response?.payload?.products || []).slice(0, 12);

        if (!products.length) return;

        const parent = this.parentNode;
        if (!parent) return;

        const fragment = document.createDocumentFragment();

        products.forEach((product) => {
          const loader = document.createElement('div');
          for (const attr of this.attributes) {
            loader.setAttribute(attr.name, attr.value);
          }
          loader.className = this.className;

          loader.innerHTML = `
            <intersection-loader
              data-section-id="product-tile"
              data-url="${product.u}"
            >
              <div class="loading animate-pulse w-full aspect-[4/5] bg-secondaryLight shadow rounded-lg relative flex items-center justify-center">
                <div class="loader !bg-transparent">
                  <span class="block w-12 h-12">
                    <svg class="animate-spin -ml-1 mr-3 h-full w-full text-primaryBrand" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                  </span>
                </div>
              </div>
            </intersection-loader>
          `;
          fragment.appendChild(loader);
        });

        parent.replaceChild(fragment, this);
      }
    }
  );
}
